import { createAsyncThunk } from '@reduxjs/toolkit';
import type { AdviserDocument } from '@syfo/types/adviser.types';

/**
 * Fetch a single adviser by UUID
 */
export const fetchAdviserThunk = createAsyncThunk<AdviserDocument, string>(
  'advisers/fetchAdviser',
  async (uuid: string) => {
    console.log(`[Advisers] Fetching adviser ${uuid}...`);
    
    const response = await fetch(`/api/advisers/${uuid}`);
    
    if (!response.ok) {
      if (response.status === 404) {
        throw new Error('Adviser not found');
      }
      throw new Error(`Failed to fetch adviser: ${response.status}`);
    }
    
    const data: AdviserDocument = await response.json();
    console.log(`[Advisers] Fetched adviser: ${data.name}`);
    return data;
  }
);
